import { useState, useEffect, createElement } from 'react';
import { useLiveRef, canUseDOM } from 'reakit-utils';
import { b as _objectWithoutPropertiesLoose, _ as _objectSpread2, c as _extends } from './_rollupPluginBabelHelpers-cb1cd42c.js';
import { Controlled } from 'react-codemirror2';
import { useOptions, useProps } from 'reakit-system';

if (typeof navigator !== "undefined") {
  require("codemirror/mode/javascript/javascript");

  require("codemirror/mode/jsx/jsx");

  require("codemirror/mode/htmlmixed/htmlmixed");

  require("codemirror/mode/diff/diff");

  require("codemirror/addon/edit/closebrackets");

  require("codemirror/addon/edit/matchbrackets");

  require("codemirror/addon/edit/matchtags");

  require("codemirror/addon/edit/closetag");

  require("codemirror/addon/fold/xml-fold");

  require("codemirror/addon/scroll/simplescrollbars");

  require("codemirror/addon/selection/active-line");

  require("codemirror/addon/display/autorefresh");
}

function PlaygroundEditor(_ref) {
  var code = _ref.code,
      update = _ref.update,
      readOnly = _ref.readOnly,
      lineWrapping = _ref.lineWrapping,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? "reakit" : _ref$theme,
      _ref$tabSize = _ref.tabSize,
      tabSize = _ref$tabSize === void 0 ? 2 : _ref$tabSize,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "jsx" : _ref$mode,
      autoRefresh = _ref.autoRefresh,
      maxHeight = _ref.maxHeight,
      htmlProps = _objectWithoutPropertiesLoose(_ref, ["code", "update", "readOnly", "lineWrapping", "theme", "tabSize", "mode", "autoRefresh", "maxHeight"]);

  var options = useOptions("PlaygroundEditor", {
    code: code,
    update: update,
    readOnly: readOnly,
    lineWrapping: lineWrapping,
    theme: theme,
    tabSize: tabSize,
    mode: mode,
    autoRefresh: autoRefresh,
    maxHeight: maxHeight
  }, htmlProps);

  var _React$useState = useState(false),
      enabled = _React$useState[0],
      setEnabled = _React$useState[1];

  var enabledRef = useLiveRef(enabled);

  var _readOnly = typeof options.readOnly !== "undefined" ? options.readOnly : !enabled;

  var _React$useState2 = useState(false),
      ready = _React$useState2[0],
      setReady = _React$useState2[1];

  htmlProps = useProps("PlaygroundEditor", _objectSpread2(_objectSpread2({}, options), {}, {
    readOnly: _readOnly
  }), htmlProps);
  var className = [htmlProps.className, !enabled && !options.readOnly && "disabled"].filter(Boolean).join(" ");
  useEffect(function () {
    var id = requestAnimationFrame(function () {
      return setReady(true);
    });
    return function () {
      return cancelAnimationFrame(id);
    };
  }, []);
  var value = options.readOnly ? options.code.trim() : options.code;

  if (!canUseDOM || !ready) {
    return /*#__PURE__*/createElement("pre", {
      className: className
    }, options.readOnly ? value : value + "\n");
  }

  return /*#__PURE__*/createElement(Controlled, _extends({}, htmlProps, {
    className: className,
    value: value,
    onBeforeChange: function onBeforeChange(_, __, val) {
      return options.update(val);
    },
    onMouseDown: function onMouseDown() {
      return setEnabled(true);
    },
    onTouchStart: function onTouchStart() {
      return setEnabled(true);
    },
    onKeyDown: function onKeyDown(_, event) {
      if (!enabledRef.current && (event.key === "Enter" || event.key === " ")) {
        event.preventDefault();
        setEnabled(true);
      } else if (event.key === "Escape") {
        event.preventDefault();
        setEnabled(false);
      }
    },
    onBlur: function onBlur() {
      return setEnabled(false);
    },
    onFocus: function onFocus() {},
    options: {
      scrollbarStyle: "overlay",
      theme: options.theme,
      readOnly: _readOnly,
      lineWrapping: options.lineWrapping,
      tabSize: options.tabSize,
      mode: options.mode,
      autoRefresh: options.autoRefresh,
      cursorBlinkRate: _readOnly ? -1 : 530,
      styleActiveLine: !_readOnly,
      smartIndent: !_readOnly,
      matchBrackets: !_readOnly,
      autoCloseBrackets: !_readOnly,
      autoCloseTags: !_readOnly,
      matchTags: !_readOnly,
      extraKeys: enabled ? {} : {
        Tab: false,
        "Shift-Tab": false
      }
    }
  }));
}

export { PlaygroundEditor };
